module.exports = __webpack_public_path__ + "images/f8c2b82304b9d7795eec65e4e1db2f55.svg";